/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_TermsInputs */

const en_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Landing_Footer_TermsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const landing_footer_terms = /** @type {((inputs?: Landing_Footer_TermsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_TermsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_terms(inputs)
});
export { landing_footer_terms as "landing.footer.terms" }